import { ReactElement } from "react"
import { RadioButton } from "@nova/ds-component-radio-button"
import { InspectorPanelAccordionKeyValueToggle } from "./InspectorPanelAccordionKeyValueToggle"
import { InspectorPanelKeyValueDropdown } from "../InspectorPanelKeyValueDropdown"
import classNames from "classnames"

type Child =
    | ReactElement<typeof InspectorPanelAccordionKeyValueToggle>
    | ReactElement<typeof InspectorPanelKeyValueDropdown>
    | false

type InspectorPanelAccordionRadioButtonProps = {
    title: string
    isSelected: boolean
    setIsSelected: (isSelected: boolean) => void
    disabled?: boolean
    children?: Child | Child[]
}

export const InspectorPanelAccordionRadioButton = ({
    title,
    isSelected,
    setIsSelected,
    disabled = false,
    children,
}: InspectorPanelAccordionRadioButtonProps) => {
    return (
        <div>
            <div
                className={classNames("flex items-center gap-2.5 h-8 group", {
                    "text-gray-500 cursor-not-allowed": disabled,
                    "text-gray-0 cursor-pointer": !disabled,
                })}
                onClick={!disabled ? () => setIsSelected(!isSelected) : () => {}}
            >
                <RadioButton
                    disabled={disabled}
                    isSelected={isSelected}
                    onClick={() => {}}
                    size="small"
                />
                <h5 className="select-none">{title}</h5>
            </div>
            <div className="pl-[1.625rem]">{children}</div>
        </div>
    )
}
